import { AnyAction } from "redux";
import { update, upload } from "../../../user";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";

export const UPLOAD_IMAGE_ANNOUNCEMENT_REQUEST =
  "UPLOAD_IMAGE_ANNOUNCEMENT_REQUEST";
export const UPLOAD_IMAGE_ANNOUNCEMENT_SUCCESS =
  "UPLOAD_IMAGE_ANNOUNCEMENT_SUCCESS";
export const UPLOAD_FILE_ANNOUNCEMENT_SUCCESS =
  "UPLOAD_FILE_ANNOUNCEMENT_SUCCESS";
export const UPLOAD_IMAGE_ANNOUNCEMENT_FAILURE =
  "UPLOAD_IMAGE_ANNOUNCEMENT_FAILURE";
export const UPLOAD_IMAGE_ANNOUNCEMENT = "UPLOAD_IMAGE_ANNOUNCEMENT";

interface ActionDefault<T> {
  type: string;
  payload: T;
}

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const uploadDataRequest = () => {
  return {
    type: UPLOAD_IMAGE_ANNOUNCEMENT_REQUEST,
  };
};

const uploadDataSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: UPLOAD_IMAGE_ANNOUNCEMENT_SUCCESS,
    payload: data,
  };
};

const uploadFileDataSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: UPLOAD_FILE_ANNOUNCEMENT_SUCCESS,
    payload: data,
  };
};

const uploadDataFailure = (error: any) => {
  return {
    type: UPLOAD_IMAGE_ANNOUNCEMENT_FAILURE,
    payload: error,
  };
};
const uploadImage = (data: any) => {
  return {
    type: UPLOAD_IMAGE_ANNOUNCEMENT,
    payload: data,
  };
};

export const UploadImageAnnouncement = (file: File) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(uploadDataRequest());
    try {
      const response = await upload(file);
      dispatch(uploadDataSuccess(response.data));
    } catch (error: any) {
      dispatch(uploadDataFailure(error.message));
    }
  };
};

export const UploadRawFileAnnouncement = (file: File) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(uploadDataRequest());
    try {
      const response = await upload(file);
      dispatch(uploadFileDataSuccess(response.data));
    } catch (error: any) {
      dispatch(uploadDataFailure(error.message));
    }
  };
};
